import React, { useState } from 'react';
import { Layout } from '../Layout/Layout';
import JobTile from '../JobTile/JobTile';
import Loader from '../Loader/Loader';

export default function JobRemoved(){
    return(
        <>
        <Layout>
            <JobTile title="Removed Jobs" type="Removed" />
        </Layout>
        </>
    )
}